// @flow

import { combineReducers, type Reducer } from "redux";
import hierarchy from "./hierarchy";
import absenceReasons from "./absence-reasons";
import absenceReview from "./absence-review";
import alerts from "./alerts";
import alertSuppression from "./alert-suppression";
import employeeAbsences from "./employee-absences";
import employeeNotifications from "./employee-notifications";
import shiftPatterns from "./shift-patterns";
import staffGroups from "./staff-groups";
import employeePositions from "./employee-positions";
import specialContactTypes from "./special-contact-types";
import employeeEvents from "./employee-events";
import selectEmployee from "./select-employee";
import home from "./home";

import { initialState as hierarchyInitialState } from "./hierarchy/state";
import { initialState as absenceReasonsInitialState } from "./absence-reasons/state";
import { initialState as absenceReviewInitialState } from "./absence-review/state";
import { initialState as alertsInitialState } from "./alerts/state";
import { initialState as alertSuppressionInitialState } from "./alert-suppression/state";
import { initialState as employeeAbsencesInitialState } from "./employee-absences/state";
import { initialState as employeeNotificationsInitialState } from "./employee-notifications/state";
import { initialState as shiftPatternsInitialState } from "./shift-patterns/state";
import { initialState as staffGroupsInitialState } from "./staff-groups/state";
import { initialState as employeePositionsInitialState } from "./employee-positions/state";
import { initialState as specialContactTypesInitialState } from "./special-contact-types/state";
import { initialState as employeeEventsState } from "./employee-events/state";
import { initialState as selectEmployeeState } from "./select-employee";
import { initialState as homeStateInitialState } from "./home";

import type { SharedState } from "./types";

export const initialState: SharedState = {
  hierarchy: hierarchyInitialState,
  absenceReasons: absenceReasonsInitialState,
  absenceReview: absenceReviewInitialState,
  alerts: alertsInitialState,
  alertSuppression: alertSuppressionInitialState,
  employeeAbsences: employeeAbsencesInitialState,
  employeeNotifications: employeeNotificationsInitialState,
  shiftPatterns: shiftPatternsInitialState,
  staffGroups: staffGroupsInitialState,
  employeePositions: employeePositionsInitialState,
  specialContactTypes: specialContactTypesInitialState,
  employeeEvents: employeeEventsState,
  selectEmployee: selectEmployeeState,
  home: homeStateInitialState,
};

export default (combineReducers({
  hierarchy,
  absenceReasons,
  absenceReview,
  alerts,
  alertSuppression,
  employeeAbsences,
  employeeNotifications,
  shiftPatterns,
  staffGroups,
  employeePositions,
  specialContactTypes,
  employeeEvents,
  selectEmployee,
  home,
}): Reducer<SharedState, *>);
